import { render, staticRenderFns } from "./CourseGroupSetting.vue?vue&type=template&id=f1685658"
import script from "./CourseGroupSetting.vue?vue&type=script&lang=ts"
export * from "./CourseGroupSetting.vue?vue&type=script&lang=ts"
import style0 from "./CourseGroupSetting.vue?vue&type=style&index=0&id=f1685658&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports